<script>
  import * as ServerTime from '../../../utils/services/pregao-server-time'
  import _base from '../../_default/components/_base.vue'
  import {merge as _merge} from 'lodash'
  // import { Status as SocketStatus } from '../../../domain/leiloes/helpers/SocketStatus'
  import * as Status from '../../../domain/leiloes/helpers/LoteStatus'
  // import {number_format as numberFormat} from '../../../utils/helpers/phpjs'
  import Service from '../../../domain/leiloes/services/patio'
  // import Comunicator from 'rogeriomenezes-comunicator'
  import moment from 'moment'
  import Relogio from './components/Relogio'

  export default {
    name: 'PregaoLeiloeiroPatio',
    extends: _base,
    data () {
      return {
        loteNum: null,
        anterior: null,
        proximo: null,
        total: 0,
        resto: 0,
        animFotos: [],
        animFotosIndex: 0,
        isComConnected: 0,
        stats: {
          condicionais: null,
          naoVendidos: null,
          totalVendas: null,
          valoresCondicionais: null,
          vendidos: null,
          saldoSucata: null,
          vendidosNaoSucata: null,
          arrematantesOnline: 0,
          espectadoresOnline: 0,
          comitentesOnline: 0,
          mediaFipe: {
            valorFipe: null,
            valorVenda: null
          }
        },
        leilao: {},
        pregao: null,
        lote: {
          numero: 0,
          imagem: null,
          descricao: '-',
          valorInicial: 0.00,
          valorIncremento: 0.00,
          valorMinimo: 0.00,
          valorMeta: 0.00,
          lancePrincipal: null,
          status: null,
          comitente: {
            pessoa: {}
          },
          pregao: null,
          lances: []
        },
        isLoading: false,
        centerContentFolded: false,
        hasNovoLance: false,
        countDownTimer: 10,
        defaultDownTimer: 10
      }
    },
    created () {
      this.load()
    },
    computed: {
      posicao: function () {
        // return this.total - this.resto + ' de ' + this.total
        return this.lote.numero + ' de ' + this.total
      },
      filteredLances: function () {
        let data = this.lote.lances
        if (!Array.isArray(data)) {
          data = []
        }
        // Ordena pelo valor de forma decrescente
        data = data.slice().sort(function (a, b) {
          a = Number(a['valor'])
          b = Number(b['valor'])
          return (a === b ? 0 : a > b ? 1 : -1) * -1 // -1 = desc, 1 = asc
        })

        return data.slice(0, 5) // Somente os 5 últimos lances
      },
      tituloLote () {
        if (this.lote.tituloPregoeiro) {
          return this.lote.tituloPregoeiro.toUpperCase()
        } else if (this.lote.titulo) {
          return this.lote.titulo.toUpperCase()
        }
        return ''
      },
      descricaoLote () {
        if (this.lote.descricaoPregoeiro) {
          return this.lote.descricaoPregoeiro.toUpperCase()
        } else if (this.lote.descricao) {
          return this.lote.descricao.toUpperCase()
        }
        return ''
      },
      observacaoLote () {
        if (this.lote.observacaoPregoeiro) {
          return this.lote.observacaoPregoeiro.toUpperCase()
        } else if (this.lote.observacao) {
          return ''
          // return this.lote.observacao.toUpperCase()
        }
        return ''
      },
      totalLotes () {
        if (typeof this.pregao === 'undefined' || this.pregao === null) {
          return 0
        }
        return this.pregao.totalLotes
      },
      totalSaldo () {
        if (typeof this.pregao === 'undefined' || this.pregao === null) {
          return 0
        }
        return Number(this.pregao.totalLotes) - (Number(this.stats.vendidos) + Number(this.stats.naoVendidos) + Number(this.stats.condicionais))
      },
      totalSaldoSucata () {
        if (typeof this.pregao === 'undefined' || this.pregao === null) {
          return 0
        }
        return Number(this.stats.saldoSucata)
      },
      percentualVenda () {
        if (!Number(this.stats.mediaFipe.valorVenda) && !Number(this.stats.mediaFipe.valorFipe)) return 0
        return this.round((Number(this.stats.mediaFipe.valorVenda) * 100) / Number(this.stats.mediaFipe.valorFipe), 2)
      },
      comitenteNome () {
        if (this.lote.comitente === null) {
          return
        }
        if (typeof this.lote.comitente.pessoa['nome'] === 'undefined') {
          return
        }
        return this.lote.comitente.pessoa.nome.toUpperCase()
      },
      lanceLocalidade: function () {
        return this.testHasProperty() ? this.filteredLances[0].arrematante.pessoa.essencial.cidade + ' - ' + this.filteredLances[0].arrematante.pessoa.essencial.uf : '-'
      },
      lanceData: function () {
        return this.testHasProperty() ? moment(this.filteredLances[0].data.date).format('L') + ' - ' + moment(this.filteredLances[0].data.date).format('LTS') : '-'
      },
      valor: function () {
        return this.testHasProperty() ? this.filteredLances[0].valor : 0
      },
      apelido: function () {
        return this.testHasProperty() ? this.filteredLances[0].arrematante.apelido : '-'
      },
      timerPregao: function () {
        if (typeof this.leilao['timerPregao'] === 'undefined') {
          return 10
        }
        return parseInt(+this.leilao.timerPregao)
      },
      timerPregaoFormatado: function () {
        let timer = Number(this.countDownTimer)
        if (timer < 60) {
          return '00:' + ('0' + timer).slice(-2)
        }
        let hora = Math.floor(timer / 60)
        let minutos = timer % 60
        return ('0' + hora).slice(-2) + ':' + ('0' + minutos).slice(-2)
      },
      Status: function () {
        return Status
      },
      statusLote: function () {
        if (this.lote.status === null) {
          return '-'
        }
        if (typeof this.Status.Status[this.lote.status] !== 'undefined') {
          return this.Status.Status[this.lote.status].titulo
        }
        return 'Status inválido'
      },
      colorStatus () {
        if (this.lote.status === null) {
          return '#FFFFFF'
        }
        if (typeof this.Status.Status[this.lote.status]['color'] !== 'undefined') {
          return this.Status.Status[this.lote.status]['color']
        }
        return '#FFFFFF'
      },
      porcentagemAvaliacao () {
        let tabelaFipe = typeof this.lote.valorTabelaFipe !== 'undefined' ? this.lote.valorTabelaFipe : 0
        let avaliacao = typeof this.lote.valorAvaliacao !== 'undefined' ? this.lote.valorAvaliacao : 0
        if (tabelaFipe > 0 && avaliacao > 0) {
          return this.round((avaliacao / tabelaFipe) * 100, 2)
        }
        return 0
      },
      porcentagemMinimo () {
        let tabelaFipe = typeof this.lote.valorTabelaFipe !== 'undefined' ? this.lote.valorTabelaFipe : 0
        let minimo = typeof this.lote.valorMinimo !== 'undefined' ? this.lote.valorMinimo : 0
        if (tabelaFipe > 0 && minimo > 0) {
          return this.round((minimo / tabelaFipe) * 100, 2)
        }
        return 0
      },
      minimoStyle () {
        return {
          'minimo-superado': Number(this.valor) >= Number(this.lote.valorMinimo)
        }
      },
      fipeLance () {
        let tabelaFipe = typeof this.lote.valorTabelaFipe !== 'undefined' ? this.lote.valorTabelaFipe : 0
        let lance = Number(this.valor)
        if (tabelaFipe > 0 && lance > 0) {
          return this.round((lance / tabelaFipe) * 100, 2) + '%'
        }
        return '0%'
      },
      classLanceOnline () {
        if (typeof this.lote.lancePrincipal !== 'undefined' && this.lote.lancePrincipal !== null && this.lote.lancePrincipal !== 'null') {
          if (this.lote.lancePrincipal.arrematante.apelido !== 'PLATEIA') {
            return ['dash-pregao-online-leiloeiro']
          }
          return ['']
        }
        return ['']
      }
    },
    mounted () {
      /* Realtime Comunicator */
      // this.wsChannel = 'pregao/' + this.$route.params.id
      /* this.comunicator = Comunicator.connect(process.env.WS_URL)
      this.comunicator.on('lance', this.onLance)
      this.comunicator.on('status', this.onStatus)
      this.comunicator.on('statusLeilao', this.onStatusLeilao)
      this.comunicator.on('tempo', this.onTempo)
      this.comunicator.on('mudaLote', this.onMudaLote)
      this.comunicator.on('lanceDeletado', this.onLanceDeletado)
      this.comunicator.on('alteracaoIncremento', this.onAlteracaoIncremento)
      this.comunicator.on('alteracaoTempo', this.onAlteracaoTempo)
      this.comunicator.on('comitenteDecisaoStatusLote', this.onComitenteDecisaoStatusLote)
      this.comunicator.on('com/connect', (env) => {
        this.isComConnected = 1
      })
      this.comunicator.on('com/disconnect', (env) => {
        this.isComConnected = 2
      })
      window.setTimeout(() => {
        if (this.isComConnected !== 1) {
          this.isComConnected = 2 // No connection alert
        }
      }, 4000) */
      /* End */

      this._showMenu(false)
      this._showHeader(true)
      this._showFooter(false)
      this._menuFolded(false)
      this.$nextTick(() => {
        this.$root.$el.classList.add('full-height')
      })
    },
    destroyed () {
      this.$root.$el.classList.remove('full-height')
    },
    methods: {
      load (id, numero) {
        this.$loaderOverlay.open().message('Aguarde enquanto carregamos o leilão')
        Service.find(this.$route.params.id, typeof id === 'undefined' ? '' : id, typeof numero === 'undefined' ? null : numero)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.isLoading = false
            this.leilao = response.data.leilao
            /* if (typeof this.leilao['timerPregao'] !== 'undefined') {
             this.$refs.painelLote.updateDefaultTimerPregao(this.leilao['timerPregao'])
             } */
            this.lote = response.data.lote
            this.pregao = response.data.pregao
            this.anterior = response.data.anterior
            this.proximo = response.data.proximo
            this.total = Number(response.data.total)
            this.resto = Number(response.data.resto)
            /* if (this.pregao !== null) {
              window.setTimeout(() => {
                this.centerContentFolded = true
                this.carregaPregao()
              }, 500)
            } */
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            // window.alert('Erro ao carregar o pregão. Tente novamente, caso o erro persista, contate o administrador do sistema.')
            window.responseError(response)
            console.log(response)
          })
      },
      voltar () {
        console.log('Voltando lote')
        if (this.anterior) {
          this.load(this.anterior)
        }
      },
      avancar () {
        console.log('Avancando lote')
        if (this.proximo) {
          this.load(this.proximo)
        }
      },
      irParaLote () {
        console.log('Ir para lote')
        let num = Number(this.loteNum)
        if (!isNaN(num) && num > 0) {
          this.load(null, num)
        }
      },
      onLance: function (data) {
        if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
          return
        }
        this.lote.lances.unshift(data.lote.lance)
        this.lote.lancePrincipal = this.filteredLances.length > 0 ? this.filteredLances.slice(0, 1).shift() : null
        this.remoteNovoLance({
          id: data.lote.id,
          status: data.lote.status,
          lancePrincipal: data.lote.lance
        }, data.lote.lance)
      },
      onStatus: function (data) {
        if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
          return
        }
        delete this.lote.pregao
        _merge(this.lote, data.lote)
        this.mountTimerCountdown()
      },
      onStatusLeilao: function (data) {
        if (!this.validateComunication(data)) {
          return
        }
        if (data.status === 6) {
          // Carrega o pregão
          this.carregaPregao()
        }
        this.leilao.status = data.status
      },
      onTempo: function (data) {
        if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
          return
        }
        console.log('TEMPO!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!', data)
        this.lote.pregao.dataAbertura.date = data.lote.tempo.date
        if (this.filteredLances.length > 0) {
          this.lote.lances[0].data = {date: data.lote.tempo}
        }
        this.$nextTick(() => {
          this.mountTimerCountdown()
        })
      },
      onMudaLote: function (data) {
        if (!this.validateComunication(data)) {
          return
        }
        this.carregaPregao()
        /* this.leilao = data.leilao
        this.pregao = data.pregao
        this.lote = data.lote
        this.$nextTick(() => {
          if (typeof this.leilao['timerPregao'] !== 'undefined') {
            this.updateDefaultTimerPregao(this.leilao['timerPregao'])
            this.mountTimerCountdown()
            this.getStatsLeilao()
          }
        }) */
      },
      onLanceDeletado: function (data) {
        if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
          return
        }
        if (this.lote.lances.length === 0) {
          return
        }
        for (let i = 0, len = this.lote.lances.length; i < len; ++i) {
          if (this.lote.lances[i].id === data.lote.lance) {
            this.lote.lances.splice(i, 1)
            break
          }
        }
        this.$nextTick(() => {
          this.updateLancePrincipal()
        })
      },
      onAlteracaoIncremento: function (data) {
        if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
          return
        }
        this.lote.valorIncremento = data.lote.incremento
      },
      onAlteracaoTempo: function (data) {
        if (!this.validateComunication(data)) {
          return
        }
        this.leilao.timerPregao = data.tempo
        let that = this
        this.$nextTick(function () {
          that.updateDefaultTimerPregao(that.leilao['timerPregao'])
          that.mountTimerCountdown()
        })
      },
      onComitenteDecisaoStatusLote: function (data) {
        console.log(data) // TODO: Fazer notificação
      },
      validateComunication: function (event) {
        if (typeof event['leilao'] === 'undefined') {
          return false
        }
        if (typeof event['leilao']['id'] !== 'undefined') {
          return event['leilao']['id'] === this.leilao.id
        }
        return event['leilao'] === this.leilao.id
      },
      validateComunicationLote: function (event) {
        if (typeof event['lote'] === 'undefined') {
          return false
        }
        if (typeof event.lote['id'] === 'undefined') {
          if (event.lote === this.lote.id) {
            return true
          }
        } else {
          if (event.lote.id === this.lote.id) {
            return true
          }
        }
        return false
      },
      round: function (number, precision) {
        let factor = Math.pow(10, precision)
        let tempNumber = number * factor
        let roundedTempNumber = Math.round(tempNumber)
        return roundedTempNumber / factor
      },
      testHasProperty: function () {
        return this.filteredLances.length > 0
      },
      toggleKeyboard (v) {
        this.centerContentFolded = v
      },
      reajustaTimerPregao: function (newTimer) {
        this.leilao.timerPregao = this.countDownTimer = newTimer
        this.$nextTick(() => {
          this.mountTimerCountdown()
        })
        console.log('Reajustando timer do pregão')
      },
      carregaPregao: function () {
        let that = this
        Service.find(this.$route.params.id)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.isLoading = false
            this.leilao = response.data.leilao
            /* if (typeof this.leilao['timerPregao'] !== 'undefined') {
             this.$refs.painelLote.updateDefaultTimerPregao(this.leilao['timerPregao'])
             } */
            this.lote = response.data.lote
            this.pregao = response.data.pregao
            this.fcnTrocaFotos(response.data.lote.imagem, response.data.lote.fotos)
            if (this.pregao !== null) {
              window.setTimeout(() => {
                this.centerContentFolded = true
                that.$nextTick(function () {
                  if (typeof that.leilao['timerPregao'] !== 'undefined') {
                    // that.updateDefaultTimerPregao(that.leilao['timerPregao'])
                    // that.mountTimerCountdown()
                  }
                })
              }, 500)
            }
            // this.getStatsLeilao()
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            // window.alert('Erro ao carregar o pregão. Tente novamente, caso o erro persista, contate o administrador do sistema.')
            window.responseError(response)
            console.log(response)
          })
      },
      getStatsLeilao () {
        /* window.setTimeout(() => {
          Service.getStatsPregao(this.leilao.id)
            .then((response) => {
              console.log(response.data)
              this.stats = response.data
            })
            .catch((error) => {
              console.log(error)
            }, 2000)
        }) */
      },
      reset: function () {
        this.countDownTimer = this.defaultDownTimer
      },
      updateDefaultTimerPregao: function (seconds) {
        this.defaultDownTimer = parseInt(seconds)
        this.countDownTimer = parseInt(seconds)
      },
      mountTimerCountdown: function () {
        let that = this
        this.$nextTick(function () {
          console.log('Countdown execute...')
          if (typeof this.$intervalCronometro !== 'undefined') {
            window.clearInterval(that.$intervalCronometro)
            that.reset()
          }
          if (typeof this.lote.pregao === 'undefined') {
            console.log('Lote não está em pregão, por isso não inicia o cronômetro.')
            return
          }
          if (this.lote.pregao !== null) {
            console.log('Inicia os ajustes do cronômetro.', this.lote.pregao)
            // Pregão está ativo e cronômetro deve funcionar
            let dataInicio = new Date(this.lote.pregao.dataAbertura.date)

            // Se existe lance, pega a data do último lance, caso tenha sido efetuado depois do pregão ser ativo
            if (this.lote.lances.length > 0) {
              let dataUltimoLance = new Date(this.lote.lances[0].data.date)
              if (dataUltimoLance.getTime() >= dataInicio.getTime()) {
                // O lance efetuado foi durante o pregão ativo
                dataInicio = dataUltimoLance
              }
            } else {
              // Caso contrário, pega a data de abertura do pregão do lote
            }
            dataInicio.setSeconds(dataInicio.getSeconds() + this.timerPregao + 1)
            let intervalFcn = function () {
              let timeNow
              if (ServerTime.serverTime > 0) {
                timeNow = ServerTime.timeNow()
              } else {
                timeNow = new Date().getTime()
              }
              let dataFim = timeNow
              let distance = dataInicio.getTime() - dataFim
              let seconds = Math.floor(distance / 1000)

              /* if( seconds < 2){
               that.lote.status = Status.STATUS_HOMOLOGANDO
               } */
              if (distance < 1) {
                window.clearInterval(that.$intervalCronometro)
                that.countDownTimer = 0
              } else {
                that.countDownTimer = seconds
              }
            }
            intervalFcn()
            this.$intervalCronometro = window.setInterval(intervalFcn, 1000)
          }
        })
      },
      updateLancePrincipal: function () { // TODO: Retirar isto. O principal sempre deve ser o último lance.
        // this.lote.lancePrincipal = this.filteredLances.length > 0 ? this.filteredLances.slice(0, 1).shift() : null
        // console.log(this.lote.lancePrincipal)
      },
      remoteNovoLance: function (lote, lance) {
        this.hasNovoLance = true
        this.$nextTick(function () {
          window.setTimeout(() => {
            this.hasNovoLance = false
          }, 100)
        })

        _merge(this.lote, lote)
        // this.updateLancePrincipal()
        // this.lote.lances.unshift(lance)
        this.mountTimerCountdown()
      },
      calcPercentTimer: function (percent) {
        let downTimer = this.timerPregao
        return (downTimer * (percent / 100))
      },
      fcnTrocaFotos: function (fotoPrincipal, fotos) {
        // let imagem1 = fotoPrincipal.match(/[^\\/]+$/)[0]
        // let url = fotoPrincipal.replace(imagem1, '')
        let animFotos = []
        // animFotos.push(fotoPrincipal)
        for (var i = 0; i < fotos.length; i++) {
          animFotos.push({active: false, image: fotos[i].url})
        }
        this.animFotos = animFotos
        console.log(animFotos)
        this.startAnimFotos()
      },
      startAnimFotos: function () {
        window.clearInterval(this._timerFotos)
        let that = this
        this.animFotosIndex = 0
        this._timerFotos = window.setInterval(function () {
          let next = that.animFotosIndex + 1
          if (typeof that.animFotos[next] !== 'undefined') {
            that.lote.imagem = that.animFotos[next].image
            that.animFotosIndex = that.animFotosIndex + 1
          } else {
            that.lote.imagem = that.animFotos[0].image
            that.animFotosIndex = 0
          }
        }, 3000)
      },
      renovarTempo: function () {
        Service.renovaTempoPregaoLote(this.$route.params.id, this.lote.id)
          .then((response) => {
            // this.$emit('renovaTempo', response.data)
          })
          .catch((response) => {
            window.responseError(response)
            console.log(response)
          })
      }
    },
    components: {Relogio}
  }
</script>

<template>
  <div class="h-full" :class="classLanceOnline">
    <div class="pregao-leiloeiro thema1 h-full" :class="{'isLoading': isLoading}">

      <div class="header-info0">
        <div class="lote-num-label">
          <!--<div class="lote-num-title">Lote</div>-->
          <div class="lote-numero"><!--Lote {{ lote.numero }}-->{{ posicao }}</div>
          <div class="lote-num-qtd-leilao">{{ Number(lote.quantidadeLeiloes) + 1}}º LEILÃO</div>
        </div>

        <div class="hora">
          <relogio></relogio>
        </div>

        <div class="comitente">
          <img :src="lote.comitente.imagemUrl"/>
        </div>
      </div>

      <div class="header-info">

        <div class="lote-details1" style="width: 100%; padding: 0 20px">

          <div class="d-row">
            <div class="d-col valor">
              <div class="title">LANCE ATUAL</div>
              <div class="d-input valorAtual" :class="{novoLance: hasNovoLance}">{{ valor | moeda }}</div>
            </div>
            <div class="d-col arrematante" :class="{online: apelido !== 'PLATEIA' && apelido !== '-'}">
              <div class="title">ARREMATANTE</div>
              <div class="d-input">
                <strong>{{ apelido }}</strong>
                <p>{{ lanceLocalidade }}</p>
              </div>
            </div>
          </div>

          <div class="d-row">
            <div class="d-col avaliacao">
              <div class="title">Valor Avaliação</div>
              <div class="d-input price">{{ lote.valorAvaliacao | moeda }}</div>
            </div>
            <div class="d-col minimo" :class="minimoStyle">
              <div class="title">Valor Mínimo</div>
              <div class="d-input price">{{ lote.valorMinimo | moeda }}</div>
            </div>
          </div>

          <div v-for="lance in lote.lances">
            <span class="hide"> {{lance.valor}}</span>
          </div>

        </div>

        <!--<div class="lote-details2 lote-status">

          <div class="status-real">
            <div class="status"><span :style="'color: ' + colorStatus">{{ statusLote }}</span></div>
            <div class="cronometro" :class="{'lance-danger': countDownTimer <= calcPercentTimer(30)}">
              {{ timerPregaoFormatado }}
            </div>

          </div>

        </div>-->

      </div>

      <div class="header-lote">
        <div class="col1">
          <div class="lote-nome" :class="{'lote-sucata': lote.condicao === 7}">{{ tituloLote }}</div>
          <div class="lote-desc">
            {{ descricaoLote }}
          </div>
          <div class="lote-obs">
            {{ observacaoLote }}
          </div>
        </div>

        <div class="image" :class="'lote-img-status' + lote.status">
          <img :src="lote.imagem">
        </div>

        <div class="time-logo-fipe">

          <div class="lote-details3 fipe">

            <div class="fipe-lance">
              <div class="title">Fipe/Lance</div>
              <div class="price">{{ fipeLance }}</div>
            </div>

            <div class="fipe-title">
              % FIPE
            </div>
            <div>
              <div class="title">Avaliação</div>
              <div class="price">{{ porcentagemAvaliacao }}%</div>
            </div>

            <div>
              <div class="title">Minimo</div>
              <div class="price">{{ porcentagemMinimo }}%</div>
            </div>

            <div>
              <div class="title">Tabela Fipe</div>
              <div class="price">R$ {{ lote.valorTabelaFipe | moeda }}</div>
            </div>

          </div>

        </div>

      </div>

      <!--<div class="lote-content">



      </div>-->

      <div class="info-footer">
        <a class="btn btn-default m-l m-b" @click="voltar">VOLTAR</a>
        <div style="display: inline-flex; flex-direction: row; align-items: center; justify-content: center; justify-items: center">IR P/ LOTE: <input size="3" v-on:keydown.enter="irParaLote" v-model="loteNum" class="m-l" /> <a class="btn btn-default m-l" @click="irParaLote">Ir</a></div>
        <a class="btn btn-default m-r m-b" @click="avancar">AVANÇAR</a>
      </div>
      <!--<div class="info-footer">
        <div> &lt;!&ndash; class="vendidos" &ndash;&gt;
          <span>Vendidos<div class="no-select" v-shortkey="['enter']" @shortkey="renovarTempo()"></div></span>
          <p>{{ stats.vendidos }}</p>
        </div>
        <div>
          <span>Condicionais</span>
          <p>{{ stats.condicionais }}</p>
        </div>
        <div>
          <span>Não Vendidos</span>
          <p>{{ stats.naoVendidos }}</p>
        </div>
        <div>
          <span>Saldo</span>
          <p>{{ totalSaldo }}</p>
        </div>
        <div>
          <span>Saldo Sucata</span>
          <p>{{ totalSaldoSucata }}</p>
        </div>
        <div>
          <span>Total</span>
          <p>{{ totalLotes }}</p>
        </div>
        <div>
          <span>Total Vendas</span>
          <p>R$ {{ stats.totalVendas | moeda }}</p>
        </div>
        <div>
          <span style="white-space: nowrap">Val. Condicionais</span>
          <p>R$ {{ stats.valoresCondicionais | moeda }}</p>
        </div>
        <div>
          <span style="white-space: nowrap">% Venda</span>
          <p>{{ percentualVenda }}</p>
        </div>
      </div>-->

    </div>
  </div>
</template>

<!--<style lang="scss" src="../pregao-leiloeiro/assets/scss/default.scss"></style>-->



// WEBPACK FOOTER //
// Main.vue?317e1531